<template>
  <span class="modifier" v-if="isNonZero(choice.srp_amount)">
    ({{ asCurrency(choice.srp_amount) }})
  </span>
</template>

<script>
import { isNonZero, asCurrency } from 'src/utilities';
import InteractsWithState from 'mixins/InteractsWithState';

export default {
  mixins: [InteractsWithState],

  props: {
    choice: {
      required: true,
    },
  },

  methods: {
    isNonZero,
    asCurrency,
  },
};
</script>

<style scoped lang="scss">
span {
  color: #888;
  padding-left: 3px;
  font-size: 0.85em;
}
</style>



// WEBPACK FOOTER //
// PriceModifier.vue?48d89500